import React from 'react';
import { CompanyLogoInfo } from '../../shared/DataStructures/CompanyLogos';
import { useWindowMedia } from '../../style/theme/hooks';
import { CompanyImage } from './CompanyImage';

interface Props {
  logo: CompanyLogoInfo;
}

export function CompanyLogo({ logo }: Props) {
  const windowMedia = useWindowMedia();
  const isMobile = windowMedia === 'mobile';
  if (isMobile && logo.mobile) {
    return <CompanyImage image={logo.mobile} />;
  }

  if (!isMobile && logo.desktop) {
    return <CompanyImage image={logo.desktop} />;
  }

  return null;
}
